import { useCallback } from 'react'

import { useQueryClient } from '../../lib/react-query/useQueryClient.js'
import { getCollectionsKey } from '../../utils/keys/collection.key.js'

export const useInvalidateCollectionsQuery = () => {
  const queryClient = useQueryClient()
  const invalidate = useCallback(() => {
    const collectionsKey = getCollectionsKey()
    queryClient.invalidateQueries(collectionsKey)
  }, [queryClient])

  return invalidate
}
